var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Badge, Chip, ChipGroup, Button } from '@patternfly/react-core';
import classNames from 'classnames';
import '../FilterChips/filter-chips.css';
function isFilterChipGroup(group) {
    return Object.prototype.hasOwnProperty.call(group, 'category');
}
function isPlainFilterChip(group) {
    return !isFilterChipGroup(group);
}
var FilterChips = function (_a) {
    var className = _a.className, _b = _a.filters, filters = _b === void 0 ? [] : _b, _c = _a.onDelete, onDelete = _c === void 0 ? function () { return undefined; } : _c, _d = _a.deleteTitle, deleteTitle = _d === void 0 ? 'Clear filters' : _d, showDeleteButton = _a.showDeleteButton, onDeleteGroup = _a.onDeleteGroup;
    var groups = filters.filter(isFilterChipGroup);
    var groupedFilters = groups.map(function (group, groupKey) { return (React.createElement(ChipGroup, __assign({ key: "group_".concat(group.category), categoryName: String(group.category) || ' ' }, (onDeleteGroup && {
        isClosable: true,
        onClick: function (event) {
            event.stopPropagation();
            onDeleteGroup(event, [group], groups.filter(function (_item, key) { return key !== groupKey; }));
        },
    })), group.chips.map(function (chip) { return (React.createElement(Chip, { key: chip.name, onClick: function (event) {
            event.stopPropagation();
            onDelete(event, [__assign(__assign({}, group), { chips: [chip] })]);
        } },
        chip.name,
        chip.count && (React.createElement(Badge, { key: "chip_badge_".concat(chip.id), isRead: chip.isRead }, chip.count)))); }))); });
    var plainFilters = filters.filter(isPlainFilterChip);
    return (React.createElement("span", { className: classNames(className, 'ins-c-chip-filters') },
        groupedFilters,
        plainFilters &&
            plainFilters.map(function (chip) { return (React.createElement(ChipGroup, { key: "group_plain_chip_".concat(chip.name) },
                React.createElement(Chip, { onClick: function (event) {
                        event.stopPropagation();
                        onDelete(event, [chip]);
                    } },
                    chip.name,
                    chip.count && (React.createElement(Badge, { key: "chip_badge_".concat(chip.id), isRead: chip.isRead }, chip.count))))); }),
        (showDeleteButton === true || (showDeleteButton === undefined && filters.length > 0)) && (React.createElement(Button, { variant: "link", ouiaId: "ClearFilters", onClick: function (event) { return onDelete(event, filters, true); } }, deleteTitle))));
};
export default FilterChips;
//# sourceMappingURL=FilterChips.js.map